(function() {
'use strict';

angular
    .module('dashboard')
    .directive('dashboardBookingSummary', dashboardBookingSummary);

function dashboardBookingSummary(dashboardBookingService, resourceService, authService) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'partials/dashboard/bookingsummary',
        scope: {
            bk: '=',
            bnd: '=',
            currentUser: '=',
            passenger: '=',
            showTripDate: '@',
            bookingMessage: '@',
            showActions: '@'
        },
        link(scope) {
            scope.bookingType = dashboardBookingService.getBookingTypeMap();
            const stopWatch = scope.$watch('bk', function(val) {
                if (val) {
                    dashboardBookingService.formatTitle(val);
                    stopWatch();
                }
            });
            scope.showTripDate = scope.showTripDate === 'true';
            scope.getResourceValue = resource => resourceService.get(resource);
            scope.formatBookingMessage = dashboardBookingService.formatBookingMessage;
            scope.bookingMessage = scope.bookingMessage === 'true';
            scope.showActions = scope.showActions === 'true';
            scope.actionRedirect = dashboardBookingService.actionRedirect;
            scope.actionClick = dashboardBookingService.actionClick;

            scope.signOut = function() {
                authService.signOut();
            };

            function revealOptions(bk) {
                bk.showOptions = true;
            }
            function hideOptions(bk) {
                bk.showOptions = false;
            }
            scope.toggleOptions = function(bk) {
                if (bk.showOptions) {
                    hideOptions(bk);
                } else {
                    revealOptions(bk);
                }
            };

            function canAccessBooking(bnd) {
                let access = true;
                // Checks bundle has a BookingUIStatus of 'OK'
                let type = _.get(bnd, '[0].Status');
                if (type !== 1) {
                    return false;
                }
                // Checks bundle components are not BookingUIStatus of 'Pending'
                access = _.every(bnd, item => {
                    return item.Status !== 2;
                });
                return access;
            }

            if (scope.bnd !== undefined) {
                scope.canAccessBooking = canAccessBooking(scope.bnd);
            }

        }
    };
}
})();
